import request from "@/utils/request";
const baseUrl = `${process.env.VUE_APP_PARTNER_GATEWAY_BASEURL}/api/v1/partner`;
export default {
  getpayoutPartnerdropdowns() {
    return request({
      url: `${baseUrl}/get-all-payout-partners`,
      method: "GET",
    });
  },
  getPartnersbymainsendprt() {
    return request({
      url: `${baseUrl}/get-partners-by-mainsendpartner`,
      method: "GET",
    });
  },
  getAllSenderCountrys() {
    return request({
      url: `${baseUrl}/get-all-sender-country`,
      method: "GET",
    });
  },
  getCountryPartners(country_code) {
    return request({
      url: `${baseUrl}/get-all-sender-partner-by-country?country=${country_code}`,
      method: "GET",
    });
  },
  getAllPayoutPartners(country_code) {
    return request({
      url: `${baseUrl}/get-all-payout-partners-by-country?country=${country_code}`,
      method: "GET",
    });
  },
  getAllPayoutPartnersBysettleCry(params) {
    return request({
      url: `${baseUrl}/get-all-payout-partners-by-settlement_currency`,
      method: "GET",
      params: params,
    });
  },
  getpayoutpartnerBycntry(country_code, payment_mode) {
    return request({
      url: `${baseUrl}/get-payout-partners?country_code=${country_code}&payment_mode=${payment_mode}`,
      method: "GET",
    });
  },
  getActivePartners() {
    return request({
      url: `${baseUrl}/get-all-active-partners`,
      method: "GET",
    });
  },
  getpayoutpartBysendingpart() {
    return request({
      url: `${baseUrl}/get-all-payout-partners`,
      method: "GET",
    });
  },
  getPartnerById(id) {
    return request({
      url: `${baseUrl}/get-partner?partner_id=${id}`,
      method: "GET",
    });
  },
  getPartnerOtherInfo(id) {
    return request({
      url: `${baseUrl}/get-other-info?partner_id=${id}`,
      method: "GET",
    });
  },
  getAgentDetails(id) {
    return request({
      url: `${baseUrl}/get-agent-function?partner_id=${id}`,
      method: "GET",
    });
  },
  getRemarks(id) {
    return request({
      url: `${baseUrl}/get-remarks?partner_id=${id}`,
      method: "GET",
    });
  },
  addpartnerCompany(data) {
    return request({
      url: `${baseUrl}/create-partner`,
      method: "POST",
      data,
    });
  },
  updatepartnerCompany(data, params) {
    return request({
      url: `${baseUrl}/update-partner?partner_id=${params}`,
      method: "PUT",
      data,
    });
  },
  UploadpartnerLogo(data, id) {
    return request({
      url: `${baseUrl}/upload-logo?partner_id=${id}`,
      method: "POST",
      data,
    });
  },
  addPartnerOtherInfo(data, id) {
    return request({
      url: `${baseUrl}/add-other-info?partner_id=${id}`,
      method: "PUT",
      data,
    });
  },
  addAgentFunction(data, id) {
    return request({
      url: `${baseUrl}/add-agent-function?partner_id=${id}`,
      method: "PUT",
      data,
    });
  },
  addRemarks(id, remark) {
    return request({
      url: `${baseUrl}/add-remarks?partner_id=${id}&remarks=${remark}'`,
      method: "PUT",
    });
  },

  getAllPartners(params) {
    return request({
      url: `${baseUrl}/all-partners`,
      method: "GET",
      params: params,
    });
  },
  deletePartner(deleteId) {
    return request({
      url: `${baseUrl}/delete-partner?partner_id=${deleteId}`,
      method: "DELETE",
    });
  },
  blockPartner(isActive, blockId) {
    return request({
      url: `${baseUrl}/block-partner?active_status=${isActive}&partner_id=${blockId}`,
      method: "PUT",
    });
  },

  //------------------------ALLOWED CURRENCY API----------------------------------
  getallAllowpartnerCurrency(code) {
    return request({
      url: `${baseUrl}/all-currency?partner_id=${code}`,
      method: "GET",
    });
  },
  PostPartnerCurrency(data) {
    return request({
      url: `${baseUrl}/add-currency`,
      method: "POST",
      data,
    });
  },
  deletePartnerCurrency(deleteId) {
    return request({
      url: `${baseUrl}/delete-allow-currency?id=${deleteId}`,
      method: "DELETE",
    });
  },
  UpdatecurrencyStatus(id, is_default) {
    return request({
      url: `${baseUrl}/update-currency-status?id=${id}&is_default=${is_default}`,
      method: "PUT",
    });
  },
  getallpartnerCurrencyid(id) {
    return request({
      url: `${baseUrl}/get-currency-by-id?id=${id}`,
      method: "GET",
    });
  },
  Updatecurrency(id, data) {
    return request({
      url: `${baseUrl}/update-allow-currency?id=${id}`,
      method: "PUT",
      data,
    });
  },
  //--------------------------------Partner Agent Details -------------------------------------//
  addpartnerAgentCompany(data) {
    return request({
      url: `${baseUrl}/create-agent`,
      method: "POST",
      data,
    });
  },
  getpartnerAgentCompany(id) {
    return request({
      url: `${baseUrl}/all-agents?parent_partner_id=${id}`,
      method: "GET",
    });
  },
  updatepartnerAgentCompany(id, data) {
    return request({
      url: `${baseUrl}/update-agents?parent_partner_id=${id}`,
      method: "PUT",
      data,
    });
  },

  //------------------------------partner Branch details ------------------------------------//
  getPartnerAllBranches(id) {
    return request({
      url: `${baseUrl}/all-branches?parent_partner_id=${id}`,
      method: "GET",
    });
  },
  getPartnerBranches(id) {
    return request({
      url: `${baseUrl}/all-partner-branches?partner_id=${id}`,
      method: "GET",
    });
  },
  getBranchbyId(id) {
    return request({
      url: `${baseUrl}/get-partner-branch?branch_id=${id}`,
      method: "GET",
    });
  },
  partnerAddBranch(data) {
    return request({
      url: `${baseUrl}/create-partner-branch`,
      method: "POST",
      data,
    });
  },
  partnerUpdateBranch(id, data) {
    return request({
      url: `${baseUrl}/update-partner-branch?branch_id=${id}`,
      method: "PUT",
      data,
    });
  },
  deletePartnerBranch(id) {
    return request({
      url: `${baseUrl}/delete-partner-branch?branch_id=${id}`,
      method: "DELETE",
    });
  },
  //------------------------------partner user details ------------------------------------//

  addPartnerUser(data) {
    return request({
      url: `${baseUrl}/add-partneruser`,
      method: "POST",
      data,
    });
  },
  generateInetgrationData(params) {
    return request({
      url: `${baseUrl}/generate-partner-api-info`,
      method: "GET",
      params: params,
    });
  },
  getPartnerUsers(id) {
    return request({
      url: `${baseUrl}/get-partner-user-by-id?id=${id}`,
      method: "GET",
    });
  },
  getAllPartnerUsers(code) {
    return request({
      url: `${baseUrl}/all-partner-user?partner_code=${code}`,
      method: "GET",
    });
  },
  //  getAllPartnerUsers(code){
  //   return request({
  //     url: `${baseUrl}/get-partner-user?partner_code=${code}`,
  //     method: "GET",
  //   });
  //  },
  getPasswordLink(login_id) {
    return request({
      url: `${baseUrl}/password-link?login_id=${login_id}`,
      method: "GET",
    });
  },
  updatePartnerUser(id, data) {
    return request({
      url: `${baseUrl}/update-partner-user?login_id=${id}`,
      method: "PUT",
      data,
    });
  },
  deletePartnerUser(id) {
    return request({
      url: `${baseUrl}/delete-partner-user?id=${id}`,
      method: "DELETE",
    });
  },

  addApiuserInfo(data) {
    return request({
      url: `${baseUrl}/add-partner-api-info`,
      method: "POST",
      data,
    });
  },
  getApiuserInfo(id) {
    return request({
      url: `${baseUrl}/get-by-user-id?user_id=${id}`,
      method: "GET",
    });
  },
  updateApiuserInfo(id, data) {
    return request({
      url: `${baseUrl}/update-partner-api-info?id=${id}`,
      method: "PUT",
      data,
    });
  },

  //------------------------------------PARTNER BANK LIST -------------------------------------------------//

  getPartnerBankList(id, payment_mode, is_active) {
    return request({
      url: `${baseUrl}/partner-bank-list?partner_id=${id}&payment_mode=${payment_mode}&is_active=${is_active}`,
      method: "GET",
    });
  },
  getPartnerPaymentMode(id) {
    return request({
      url: `${baseUrl}/get-payment-modes?partner_id=${id}`,
      method: "GET",
    });
  },
  updateStatus(data) {
    return request({
      url: `${baseUrl}/activate-partner-bank`,
      method: "PUT",
      data,
    });
  },
  getAllSenderPartners() {
    return request({
      url: `${baseUrl}/get-all-sender-partners`,
      method: "GET",
    });
  },
  getAllBranches(id) {
    return request({
      url: `${baseUrl}/all-branches?parent_partner_id=${id}`,
      method: "GET",
    });
  },

  //---------------------------Partner Payment Modes API's--------------------------------------------//

  getAllPayments(id, txn_type) {
    return request({
      url: `${baseUrl}/get-all-payment-modes-by-partner?partner=${id}&txn_type=${txn_type}`,
      method: "GET",
    });
  },
  getAllPaymentsbyPartnerId(id) {
    return request({
      url: `${baseUrl}/get-all-payment-modes-by-partner-id?partner_id=${id}`,
      method: "GET",
    });
  },
  getPaymentById(id) {
    return request({
      url: `${baseUrl}/get-payment-mode?id=${id}`,
      method: "GET",
    });
  },
  addPaymentMode(data) {
    return request({
      url: `${baseUrl}/add-partner-payment-mode`,
      method: "POST",
      data,
    });
  },
  updatePaymentMode(id, data) {
    return request({
      url: `${baseUrl}/update-payment-mode?id=${id}`,
      method: "PUT",
      data,
    });
  },
  isactiveStatusPayMode(id, isactive) {
    return request({
      url: `${baseUrl}/update-status?id=${id}&is_active=${isactive}`,
      method: "PUT",
    });
  },

  //---------------------------------- DEPOSITE CHANNEL ---------------------------------------------//

  getAllDepositeChannels(id) {
    return request({
      url: `${baseUrl}/get-all-deposit-channels-by-partner?partner_id=${id}`,
      method: "GET",
    });
  },
  getDepositeChannelById(id) {
    return request({
      url: `${baseUrl}/get-partner-deposit-channel?id=${id}`,
      method: "GET",
    });
  },
  addDepositeChannel(data) {
    return request({
      url: `${baseUrl}/add-partner-deposit-channel`,
      method: "POST",
      data,
    });
  },
  updateDepositeChannel(id, data) {
    return request({
      url: `${baseUrl}/update-partner-deposit-channel?id=${id}`,
      method: "PUT",
      data,
    });
  },
  deleteDepositeChannel(id) {
    return request({
      url: `${baseUrl}/delete-partner-depositchannel?id=${id}`,
      method: "DELETE",
    });
  },
  updateStatusDepositeChannel(params) {
    return request({
      url: `${baseUrl}/update-status-partner-depositchannel`,
      method: "PUT",
      params: params,
      data: params,
    });
  },

  //---------------------------User Search ------------------------//

  getUserSearchData(params) {
    return request({
      url: `${baseUrl}/get-partner-user-summary`,
      method: "GET",
      params,
    });
  },
  updateUserSearchStatus(id, is_active) {
    return request({
      url: `${baseUrl}/update-user-status?id=${id}&is_active=${is_active}`,
      method: "PUT",
    });
  },
  getMainRecList() {
    return request({
      url: `${baseUrl}/get-main-payout-partners`,
      method: "GET",
    });
  },
};
